import { type QueryObserverResult, useQuery } from '@tanstack/react-query'
import type { AxiosRequestConfig } from 'axios'
import { DateTime } from 'luxon'

import type {
  GetMeSuccess,
  GetMeError,
} from '@hublo/bff-worker-api-types/MeController/getMe'

import {
  axiosGet,
  axiosGetWithoutInterceptor,
} from '../logic/axios/wrappers/axios.get.wrapper'

import { getWorkerProfileUrl } from './config'

export const useWorkerProfileQueryKey = 'get-worker-profile'

export const hublerProfileQueryFn = async (config?: AxiosRequestConfig) => {
  const data = await axiosGet<GetMeSuccess>(getWorkerProfileUrl, config)

  return {
    ...data,
    birthday: data?.birthday
      ? DateTime.fromISO(data.birthday).toISODate()
      : undefined,
  }
}

export const noInterceptorHublerProfileQueryFn = async (
  config?: AxiosRequestConfig,
) => {
  const data = await axiosGetWithoutInterceptor<GetMeSuccess>(
    getWorkerProfileUrl,
    config,
  )

  return {
    ...data,
    birthday: data?.birthday
      ? DateTime.fromISO(data.birthday).toISODate()
      : undefined,
  }
}

export const useWorkerProfileQuery = (
  enabled = true,
  key = useWorkerProfileQueryKey,
): QueryObserverResult<GetMeSuccess, GetMeError> => {
  const isFromTests = process.env.NODE_ENV === 'test'

  return useQuery({
    queryKey: [key],
    queryFn: hublerProfileQueryFn,
    staleTime: 20 * 60 * 1000,
    enabled: key === 'checkForbiddenState' ? enabled : enabled || isFromTests,
  })
}
